/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SellerOfRecordEnum = 'VMWARE' | 'AWS' | 'INACTIVE_SELLER';

export const SellerOfRecordEnum = {

    VMWARE: 'VMWARE' as SellerOfRecordEnum,

    AWS: 'AWS' as SellerOfRecordEnum,

    INACTIVE_SELLER: 'INACTIVE_SELLER' as SellerOfRecordEnum
};

